export default import.meta.ROLLDOWN_FILE_URL_d0Hpqo6CHbR4aLffD8v8Hg